import React, { useEffect } from 'react';
import { useParams, Link, useLocation } from 'react-router-dom';
import './Project.css';

// Project Data Dictionary
const projectData = {
    'jangoz': {
        title: 'Jangoz',

        location: 'Chrompet, Chennai',
        client: 'Mr. Akash',
        programme: 'Residential / Home Interior',
        status: 'Completed',
        heroImage: '/assets/jangoz/jangoz1.JPG',
        description: [
            'A premium, highly sophisticated home interior project executed with state-of-the-art finishes, customized lighting systems, and bespoke modular layouts.',
            'Our team orchestrated structural detailing with cozy contemporary aesthetics, optimizing every corner to provide unparalleled luxury and functional comfort.'
        ],
        images: Array.from( { length: 12 }, ( _, i ) => `/assets/jangoz/jangoz${ i + 1 }.JPG` )
    },
    'manoj-bhavan': {
        title: 'Manoj Bhavan',
        subtitle: 'Corporate Workplace Interiorss',
        location: 'Chennai, India',
        client: 'kishore Corporate',
        programme: 'Corporate Interior',
        status: 'Completed',
        heroImage: '/assets/manoj bhavan/manojbhavan1.jpg',
        description: [
            'An ultra-modern corporate office workspace designed to foster dynamic collaboration, agile output, and employee wellness.',
            'Integrating warm lighting controls, custom acoustic panelings, and highly ergonomic corporate desks to produce a premium workplace aesthetic.'
        ],
        images: [
            '/assets/manoj bhavan/manojbhavan1.jpg',
            '/assets/manoj bhavan/manojbhavan2.jpg',
            '/assets/manoj bhavan/manojbhavan3.jpg'
        ]
    },
    'padmam': {
        title: 'Padmam',
        subtitle: 'Commercial Restaurant Interior',
        location: 'Chennai, India',
        client: 'sathya Restaurant Group',
        programme: 'Commercial Restaurant',
        status: 'Completed',
        heroImage: '/assets/Padmam/HRP00005.jpg',
        description: [
            'A premium fine-dining commercial restaurant interior combining high-end modern materials with warm welcoming hospitality elements.',
            'Every seating booth, ceiling detail, and service counter is meticulously designed to support peak operational workflows while offering a stunning social dining experience.'
        ],
        images: [
            'HRP00005.jpg', 'HRP00030.jpg', 'HRP09683.jpg', 'HRP09685.jpg', 'HRP09690.jpg',
            'HRP09703.jpg', 'HRP09708.jpg', 'HRP09712.jpg', 'HRP09715.jpg', 'HRP09722.jpg',
            'HRP09737.jpg', 'HRP09757.jpg', 'HRP09766.jpg', 'HRP09773.jpg', 'HRP09784.jpg',
            'HRP09789.jpg', 'HRP09791.jpg', 'HRP09795.jpg', 'HRP09807.jpg', 'HRP09821.jpg',
            'HRP09829.jpg', 'HRP09836.jpg', 'HRP09863.jpg', 'HRP09889.jpg', 'HRP09892.jpg',
            'HRP09908.jpg', 'HRP09920.jpg', 'HRP09943.jpg', 'HRP09946.jpg', 'HRP09967.jpg',
            'HRP09981.jpg', 'HRP09992.jpg'
        ].map( img => `/assets/Padmam/${ img }` )
    },
    'rwd-club-house': {
        title: 'RWD Club House',
        subtitle: 'Architecture & Structural Solutions',
        location: 'Chennai, India',
        client: 'RWD Developers',
        programme: 'Architecture Design',
        status: 'Completed',
        heroImage: '/assets/rwd club house/rwdclubhouse1.JPG',
        description: [
            'A majestic club house architectural masterpiece showcasing modern geometric forms, premium lifestyle amenities, and spacious community halls.',
            'Bridging seamless indoor-outdoor connections using large glazing windows, solid columns, and a majestic swimming deck area.'
        ],
        images: Array.from( { length: 24 }, ( _, i ) => `/assets/rwd club house/rwdclubhouse${ i + 1 }.JPG` )
    },
    'surya-bhavan': {
        title: 'Surya Bhavan',
        subtitle: 'Premium Home Interior',
        location: 'Chennai, India',
        client: 'Surya Bhavan',
        programme: 'Residential / Home Interior',
        status: 'Completed',
        heroImage: '/assets/surya bhavan/suryabhavan1.jpeg',
        description: [
            'A refined and elegant home interior project crafted with a meticulous attention to detail, blending timeless design principles with contemporary luxury finishes.',
            'From bespoke cabinetry to curated lighting schemes, every element was thoughtfully designed to create a warm, sophisticated, and highly functional living space.'
        ],
        images: Array.from( { length: 18 }, ( _, i ) => `/assets/surya bhavan/suryabhavan${ i + 1 }.jpeg` )
    },
    'vip-residential': {
        title: 'VIP Residential',
        subtitle: 'Luxury Residential Interior',
        location: 'Chennai, India',
        client: 'VIP Residential Group',
        programme: 'Residential / Home Interior',
        status: 'Completed',
        heroImage: '/assets/VIP residential/VIP residental1.jpeg',
        description: [
            'An opulent VIP residential interior project that redefines luxury living with high-end materials, statement furniture, and precision-engineered spatial planning.',
            'Every room reflects an immaculate blend of grandeur and comfort, offering residents an unparalleled lifestyle experience through world-class interior craftsmanship.'
        ],
        images: Array.from( { length: 35 }, ( _, i ) => `/assets/VIP residential/VIP residental${ i + 1 }.jpeg` )
    },
    'dbs-workspace': {
        title: 'DBS Workspace',
        subtitle: 'Modern Corporate Office Interior',
        location: 'Chennai, India',
        client: 'DBS Group',
        programme: 'Corporate Interior',
        status: 'Completed',
        heroImage: '/assets/DBS workspace/Dbs workspace1.jpeg',
        description: [
            'A sleek and contemporary corporate workspace designed to inspire productivity, innovation, and seamless team collaboration in a premium office environment.',
            'Incorporating smart space planning, professional-grade acoustic solutions, and a refined material palette that communicates brand identity through design excellence.'
        ],
        images: Array.from( { length: 15 }, ( _, i ) => `/assets/DBS workspace/Dbs workspace${ i + 1 }.jpeg` )
    }
};

function ParticularProject ()
{
    const { id } = useParams();


    // Normalize key or fallback to jangoz
    const projectKey = id && projectData[ id ] ? id : 'jangoz';
    const currentProject = projectData[ projectKey ];

    // Use clicked image as hero if provided, else fallback to standard heroImage

    useEffect( () =>
    {
        // Scroll smoothly to top on mount / change
        window.scrollTo( { top: 0, behavior: 'smooth' } );
    }, [ projectKey ] );

    return (
        <section className="tc-single-project-main-section">
            {/* Hero Cover Header */ }
            <div
                className="tc-single-project-hero"
                style={ { backgroundImage: `url('${ currentProject.heroImage }')` } }
            >
                <div className="tc-single-project-hero-overlay">
                    <h1 className="tc-single-project-hero-title">
                        { currentProject.title }
                    </h1>
                    {/* <p className="tc-single-project-hero-subtitle">
                        { currentProject.subtitle }
                    </p> */}
                </div>

            </div>

            {/* Overview & Metadata Details */ }
            <div className="tc-single-project-overview" id="project-overview-section">
                <div className="container">
                    <h2 className="tc-single-project-overview-title">
                        Project Overview
                    </h2>

                    <div className="tc-single-project-overview-grid">
                        {/* LOCATION */ }
                        <div className="tc-single-project-overview-item">
                            <i className="tc-single-project-overview-icon fal fa-map-marker-alt"></i>
                            <span className="tc-single-project-overview-label">Location</span>
                            <span className="tc-single-project-overview-value">{ currentProject.location }</span>
                        </div>

                        {/* CLIENT */ }
                        <div className="tc-single-project-overview-item">
                            <i className="tc-single-project-overview-icon fal fa-user"></i>
                            <span className="tc-single-project-overview-label">Client</span>
                            <span className="tc-single-project-overview-value">{ currentProject.client }</span>
                        </div>

                        {/* PROGRAMME */ }
                        <div className="tc-single-project-overview-item">
                            <i className="tc-single-project-overview-icon fal fa-briefcase"></i>
                            <span className="tc-single-project-overview-label">Programme</span>
                            <span className="tc-single-project-overview-value">{ currentProject.programme }</span>
                        </div>

                        {/* STATUS */ }
                        <div className="tc-single-project-overview-item">
                            <i className="tc-single-project-overview-icon fal fa-check-circle"></i>
                            <span className="tc-single-project-overview-label">Status</span>
                            <span className="tc-single-project-overview-value">{ currentProject.status }</span>
                        </div>
                    </div>

                    {/* Detailed Philosophy / Description */ }
                    <div className="tc-single-project-desc-wrapper">
                        { currentProject.description.map( ( paragraph, idx ) => (
                            <p className="tc-single-project-desc-text" key={ idx }>
                                { paragraph }
                            </p>
                        ) ) }
                    </div>
                </div>
            </div>

            {/* Grid of Folder Images */ }
            <div className="tc-single-project-images-section">
                <div className="container-fluid">
                    <div className="tc-single-project-images-grid">
                        { currentProject.images.map( ( imgSrc, index ) => (
                            <div className="tc-single-project-img-card" key={ index }>
                                <img
                                    src={ imgSrc }
                                    alt={ `${ currentProject.title } asset ${ index + 1 }` }
                                    className="tc-single-project-img"
                                    loading="lazy"
                                />
                            </div>
                        ) ) }
                    </div>
                </div>
            </div>
            <div className="text-center">
                <a
                    href="/contact"
                    className="butn rounded-pill mt-80 hover-bg-black bg-orange1 text-white"
                >
                    <span>
                        Get A Free Quote Now
                        <i className="small ms-1 ti-arrow-top-right"></i>
                    </span>
                </a>
            </div>

        </section>

    );
}

export default ParticularProject;
